module.exports = __webpack_public_path__ + "static/img/login_bg@2x.eedb4d32.png";